import React, { useMemo } from 'react';
import block from 'bem-cn';
// import PT from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

import './PaymentHistoryItem.scss';

const b = block('payment-history-item');

dayjs.extend(customParseFormat);

const PaymentHistoryItem = ({ item }) => {
  const { locale } = useSelector(state => state.locale);

  const {
    id,
    status,
    fromCurrencyAmount,
    toCurrencyAmount,
    createdAt,
  } = item;

  const statusText = useMemo(() => {
    switch (status) {
      case 1: return locale.success;
      case 2: return locale.failed;
      case 3: return locale.timeIsUp;
      default: return locale.pending;
    }
  }, [status, locale]);

  return (
    <Link className={b()} to={`/payment/bithide/${id}`}>
      <div className={b('row')}>
        <div className={b('data')}>
          <p className={b('data-label')}>{locale.date}</p>
          <p className={b('data-value')}>
            {dayjs(createdAt).format('DD.MM.YYYY, HH:mm')}
          </p>
        </div>

        <div className={b('data')}>
          <p className={b('data-label')}>{locale.status}</p>
          <p className={b('data-value', { color: status.toString() })}>
            {statusText}
          </p>
        </div>
      </div>

      <div className={b('row')}>
        <div className={b('data')}>
          <p className={b('data-label')}>{locale.amountPaid}</p>
          <p className={b('data-value')}>
            {`${fromCurrencyAmount} USDT`}
          </p>
        </div>

        <div className={b('data')}>
          <p className={b('data-label')}>{locale.amountOfPurchasedBalance}</p>
          <p className={b('data-value')}>
            {toCurrencyAmount}
          </p>
        </div>
      </div>
    </Link>
  );
};

PaymentHistoryItem.propTypes = {};

export default PaymentHistoryItem;
